const INVALID_FILENAME_CHARS = /[<>:"/\\|?*\u0000-\u001f]/g;
const EMOJI_CHARS = /\p{Extended_Pictographic}|\uFE0F|\u200D/gu;

export const sanitizeFileName = (value: string, fallback = 'hot-topic'): string => {
  const sanitized = String(value || '')
    .replace(EMOJI_CHARS, '')
    .replace(INVALID_FILENAME_CHARS, '')
    .replace(/\s+/g, ' ')
    .trim()
    .replace(/[. ]+$/g, '')
    .slice(0, 80);

  return sanitized || fallback;
};

export const getStudioExportExtension = (mimeType?: string): 'jpg' | 'png' =>
  mimeType === 'image/png' ? 'png' : 'jpg';

const padTwo = (value: number): string => String(value).padStart(2, '0');

export const formatStudioExportTimestamp = (date: Date): string =>
  `${date.getFullYear()}${padTwo(date.getMonth() + 1)}${padTwo(date.getDate())}-${padTwo(date.getHours())}${padTwo(
    date.getMinutes()
  )}${padTwo(date.getSeconds())}`;

export const getStudioExportFileName = (
  title: string,
  pageNumber: number,
  mimeType?: string,
  exportedAt?: Date
): string => {
  const stamp = exportedAt ? `-${formatStudioExportTimestamp(exportedAt)}` : '';
  return `${sanitizeFileName(title)}-${pageNumber}${stamp}.${getStudioExportExtension(mimeType)}`;
};
